import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BugReport, PlayArrow, ExitToApp, Language, ArrowDropDown, ArrowDropUp } from "@material-ui/icons";
import cookieManager from "../../components/CookieManager";
import Localize from "../../components/Localize/Localize";
import LocalizeKeys from "../../components/Localize/LocalizeKeys";
import Constants from "../../components/Constants";
import withWhitelist from "../../hoc/withWhitelist";
import "./NavBar.css";

const NavBar = ({ showLanguage = true, showLogout = true, showPlay = true }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const handleLogout = () => {
        cookieManager.remove(Constants.ACCESS_TOKEN);
        cookieManager.remove(Constants.REFRESH_TOKEN);
        cookieManager.remove(Constants.SKILLS_ID);
        cookieManager.remove(Constants.LANGUAGE);
        navigate("/login");
    };

    const handlePlay = () => {
        navigate("/play");
    };

    const changeLanguage = async (lng) => {
        await Localize.setLanguage(lng);
        window.location.reload();
    };

    const languages = [
        { code: "en", nameKey: "English" },
        { code: "es", nameKey: "Español" },
        { code: "de", nameKey: "Deutsch" },
        { code: "fr", nameKey: "Français" },
        { code: "it", nameKey: "Italiano" },
        { code: "pt", nameKey: "Português" },
    ];

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const LogOutButton = () => (
        <button className="button logout-button" onClick={handleLogout}>
            <ExitToApp />
        </button>
    );
    
    const PlayButton = withWhitelist(() => (
        <button className="button play-button" onClick={handlePlay}>
            <PlayArrow />
        </button>
    ));    
    return (
      <div className="navbar">
        <div className="navbar-title">
          <img src="/assets/favicon.ico" alt="Logo" className="navbar-logo" />
          <span>{Localize.translate(LocalizeKeys.TITLE)}</span>
        </div>

        <div className="button-container">
          <div className="dropdown-container" ref={dropdownRef}>
            <button
              className="button"
              onClick={() => setIsDropdownOpen((prev) => !prev)}
              style={{ display: "flex", alignItems: "center" }}
            >
              <span
                style={{
                  marginLeft: "-5px",
                  marginRight: "-5px",
                  marginBottom: "-5px",
                }}
              >
                {<Language />}
              </span>
              <span
                style={{
                  marginLeft: "-5px",
                  marginRight: "-10px",
                  marginBottom: "-5px",
                }}
              >
                {isDropdownOpen ? <ArrowDropUp /> : <ArrowDropDown />}
              </span>
            </button>
            <div className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  className="dropdown-item"
                  onClick={() => changeLanguage(lang.code)}
                >
                  {Localize.translate(lang.nameKey)}
                </button>
              ))}
            </div>
          </div>

          {showPlay && <PlayButton />}

          {showLogout && <LogOutButton />}
        </div>
      </div>
    );
};

export default NavBar;
